'use client';

import { selectProduct } from '@castlery/modules-product-domain';
import { useAppSelector } from '@castlery/shared-redux-store';
import LazyLoad from 'react-lazyload';
import { Box, useBreakpoints } from '@castlery/fortress';
import { ProductCollection } from '../product-recommendations/components/product-collection';
import { DYRecommendationCarousel } from '@castlery/shared-components';

export const ProductDyRecommendationsClient = () => {
  const product = useAppSelector(selectProduct);
  const { mobile, tablet } = useBreakpoints();
  return (
    <>
      <LazyLoad offset={300} once placeholder={<Box sx={{ height: mobile ? '470px' : tablet ? '486px' : '592px' }} />}>
        <DYRecommendationCarousel
          selector_name="PDP Recommendation API #2"
          fallbackWidget={
            (product?.cross_sell?.length ?? 0) > 0 &&
            (product?.collections?.length ?? 0) > 0 &&
            product?.collections ? (
              <ProductCollection title="Goes Well With" collectionIds={product.collections} />
            ) : (
              <></>
            )
          }
          containerSx={{
            pt: mobile ? 7 : 8,
          }}
        />
      </LazyLoad>
      <LazyLoad offset={300} once placeholder={<Box sx={{ height: mobile ? '470px' : tablet ? '486px' : '592px' }} />}>
        <DYRecommendationCarousel
          selector_name="PDP Recommendation API #3"
          containerSx={{
            pt: mobile ? 7 : 8,
          }}
        />
      </LazyLoad>
    </>
  );
};
